const __default__ = {
  name: "SortableList",
  methods: {
    handleCancel: function (e) {
      this.$emit("cancel", e);
    },
    handleSave: function (e) {
      this.isEdited = false;
      this.$emit("save", e);
    }
  }
};
import { ref, toRefs } from "vue"; // eslint-disable-next-line vue/valid-define-props

export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    items: {
      type: Array,
      default: () => []
    },
    columnLabel: {
      type: String,
      default: ""
    },
    builtInCancelButton: {
      type: Boolean,
      default: true
    },
    builtInSaveButton: {
      type: Boolean,
      default: true
    },
    builtInEditButton: {
      type: Boolean,
      default: false
    },
    builtInEditLink: {
      type: String,
      default: ""
    }
  },

  setup(__props, {
    expose
  }) {
    const props = __props;
    const {
      items,
      columnLabel,
      builtInCancelButton,
      builtInSaveButton,
      builtInEditButton,
      builtInEditLink
    } = toRefs(props);

    const createIndexOrderItemList = () => {
      return items.value.sort((a, b) => {
        return a.index < b.index ? -1 : a.index > b.index ? 1 : 0;
      });
    };

    const indexOrderItemList = ref(createIndexOrderItemList());
    const isEdited = ref(false);

    const changeOrderUp = index => {
      isEdited.value = true;
      const sortIndex = indexOrderItemList.value[index].index;
      indexOrderItemList.value[index].index = indexOrderItemList.value[index - 1].index;
      indexOrderItemList.value[index - 1].index = sortIndex;
      indexOrderItemList.value.splice(index - 1, 2, indexOrderItemList.value[index], indexOrderItemList.value[index - 1]);
    };

    const changeOrderDown = index => {
      isEdited.value = true;
      const sortIndex = indexOrderItemList.value[index].index;
      indexOrderItemList.value[index].index = indexOrderItemList.value[index + 1].index;
      indexOrderItemList.value[index + 1].index = sortIndex;
      indexOrderItemList.value.splice(index, 2, indexOrderItemList.value[index + 1], indexOrderItemList.value[index]);
    };

    expose({
      isEdited
    });
    return {
      __sfc: true,
      props,
      items,
      columnLabel,
      builtInCancelButton,
      builtInSaveButton,
      builtInEditButton,
      builtInEditLink,
      createIndexOrderItemList,
      indexOrderItemList,
      isEdited,
      changeOrderUp,
      changeOrderDown
    };
  }

});